import { render, staticRenderFns } from "./emailUpdateIssue.vue?vue&type=template&id=6d7c9b50&"
import script from "./emailUpdateIssue.vue?vue&type=script&lang=ts&"
export * from "./emailUpdateIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports